"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  CopyPaste: ['copy-paste', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25,8.249v-3a1.5,1.5,0,0,0-1.5-1.5h-4', 'M6.25,3.749h-4a1.5,1.5,0,0,0-1.5,1.5v16.5a1.5,1.5,0,0,0,1.5,1.5h6', 'M14.421,4.736a.751.751,0,0,1-.712.513H7.291a.751.751,0,0,1-.712-.513l-1-3A.749.749,0,0,1,6.291.749h8.418a.749.749,0,0,1,.712.987Z', 'M11.250 11.249 L23.250 11.249 L23.250 23.249 L11.250 23.249 Z', 'M14.25 14.249L20.25 14.249', 'M14.25 17.249L20.25 17.249', 'M14.25 20.249L16.5 20.249']],
  Scissors: ['scissors', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.750 17.999 A3.750 3.750 0 1 0 23.250 17.999 A3.750 3.750 0 1 0 15.750 17.999 Z', 'M15.750 5.999 A3.750 3.750 0 1 0 23.250 5.999 A3.750 3.750 0 1 0 15.750 5.999 Z', 'M.751,16.9a19.434,19.434,0,0,0,3.716.476A11.23,11.23,0,0,0,15.75,6', 'M.751,7.1a19.367,19.367,0,0,1,3.716-.477A11.23,11.23,0,0,1,15.75,18']],
  Scissors2: ['scissors-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 19.499 A3.750 3.750 0 1 0 8.250 19.499 A3.750 3.750 0 1 0 0.750 19.499 Z', 'M0.750 4.499 A3.750 3.750 0 1 0 8.250 4.499 A3.750 3.750 0 1 0 0.750 4.499 Z', 'M23.25 20.249L2.25 7.499', 'M23.25 3.749L2.25 16.499']]
};
exports["default"] = _default;